<template>
	<BaseButton
		class="link-yellow text-strong-base"
		@click="$routerHelpers.navigateToWorkspaceSettings('subscription-plan')"
	>
		<template #icon>
			<BaseIcon name="mono/sparkle" />
		</template>
		Upgrade to team plan
	</BaseButton>
</template>
